import { EntityCollectionServiceBase, EntityCollectionServiceElementsFactory } from '@ngrx/data';
import { Injectable } from '@angular/core';
import { GameTags } from '@core/models/game-tags.model';

@Injectable()
export class GameTagsEntityService extends EntityCollectionServiceBase<GameTags> {
  constructor(serviceElementsFactory: EntityCollectionServiceElementsFactory) {
      super('GameTags', serviceElementsFactory);
  }
}
